export default {
  // 订阅列表
  subscriptionList: {
    title: 'My Subscription',
    subscriptionDetail: 'Subscription Detail',
    changeAddress: 'Change Address',
    productType: 'Product Type',
    subscriptionStatusList: [
      {
        value: '',
        label: 'All',
      },
    ],
    noOrders: 'No orders under this category. Browse more courses provided by Think Academy.',
    moreCourses: 'Browse More Courses',
    noSubscriptionText: 'You currently do not have any auto-renewal subscriptions',
    unSubscribeTipsTitle: 'Please contact your learning center to cancel the subscription',
    unSubscribeTipsContent: 'After cancelling the subscription, there will be no charges for the next month. Existing orders will not affect ongoing classes.',
    autoRenewal: 'Auto Renewal',
    openRecords: 'Activation Records',
    learnPlayTag: 'Math',
    every: 'Every',
    timeLimit: 'Period',
    month: 'months',
    phase: 'Phase',
    stage: 'Stage {num}',
    deductionDate: 'Deduction Date',
    deductionAmount: 'Deduction Amount',
    status: 'Status',
    statusText: {
      1: 'To be paid',
      2: 'Paid',
      3: 'Payment Failed',
    },
    unsubscribe: 'Unsubscribe',
    weekMap: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    weekMapFull: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    weekDayList: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthsList: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    monthsListFull: [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December',
    ],
    curriculumSchedule: 'Curriculum schedule',
    today: 'today',
    classBegun: 'started',
    unClassBegun: 'not started',
    noClasses: 'No classes today',
    activedTip: 'Click the check box to activated',
    finished: 'Finished',
    notFinished: 'Not Finished',
    notStarted: 'Not Started',
    subAssessment: 'Knowledge Assessment:',
    subPreview: 'Knowledge Preview:',
    excellent: 'Excellent',
    good: 'Good',
    scheduled: 'Scheduled for Review',
    viewLesson: 'View Lesson Report',
    viewHomework: 'View Homework',
    doHomework: 'Do Homework',
    noLessons: 'No lessons on this day',
    noKnowledge: 'We will generate personalized learning content after your child completes their current lessons.',
    relearn: 'Relearn',
  },
  subscriptionCard: {
    pay: 'Pay',
    unsuceess: 'Unsuceessful Deduction',
    viewOrder: 'View Order',
    start: 'Start Time',
    end: 'End Time',
    nextPay: 'Estimated Next Payment',
    expire: 'Expiration Time',
    expireDate: 'Expiry Date',
    orderTime: 'Order Time',
    statusText: {
      1: 'To be paid',
      2: 'Active',
      3: 'Active',
      4: 'Cancelled',
    },
    paymentMethod: 'Payment Method',
    pos: 'Installment Payment via POS',
    card: 'Card',
    MakeupPayment: 'Repay',
  },
  subscriptionDetail: {
    cancel: 'Cancel Subscription',
    cancelReasons: 'Cancel Reasons',
    title: 'Subscription Detail',
  },
  // 支付失败结果页提示文案
  toBePaidResult: {
    title: 'Important Payment Reminder',
    content: 'If you have been deducted, but the order is not in the "paid" status, it may be because we have not received the banks deduction notification yet. Please check later. If you have any questions, please contact us at:',
    confirm: 'Got it!',
  },
  personalInfo: {
    childEdit: 'Child\'s Profile',
    phone: 'Mobile Number',
    emailAddress: 'Email Address',
    manage: 'Manage my children and personal information',
    manageChild: 'Manage my children',
    edit: 'Edit my profile',
  },
  childFilter: {
    child: 'Child',
    type: 'Type',
    kids: 'Kids',
    save: 'Save',
  },
  address: {
    noAddress: 'You haven\'t added an address yet',
  },
  coupon: {
    title: 'My Coupons',
    detail: 'Coupon Details',
    recommendClass: 'Recommended Class',
    testResult: 'Understanding the test result',
    on: 'On {feeName}',
    over: 'Over {symbol}{price}',
    off: '%Off',
    offThousand: '‰Off',
    noAvailable: 'No available course can be applied to the chosen coupon.',
    redeemFailedTips: 'Promo code not found. Please try again',
    redeemFailedCodeText: {
      4003: 'Sorry, this event has ended.',
      7003: 'Sorry, this event is for new students only.',
      7004: 'You have already participated in this event.',
      7005: 'You have already participated in this event.',
    },
  },
  courses: {
    title: 'Courses',
    availableClass: 'Available Classes',
    noCoursesTip: 'No courses under this category. Browse more courses provided by Think Academy.',
    moreCourses: 'Browse More Courses',
  },
  tips: {
    editSuccess: 'Student edited successfully',
    copyFiled: 'Copied Failed',
    copySuccess: 'Copied Successfully',
    success: 'Successfully',
    redeemSuccess: 'Redeem Successful',
    addSuccess: 'Student added successfully',
    login: 'Please Login again',
    loginTips: 'Your login session has expired. Please login again to continue',
    cancel: 'Cancel',
    loginAgain: 'Login Again',
    invalid: 'The input is required',
    removeWish: 'Removed from the wish list',
    loading: 'Loading...',
    deleteSuccess: 'Delete Successful',
    addSuccessful: 'Add Successful',
    updateSuccess: 'Update Successful',
    updateFailed: 'Update failed. Same with the previous address.',
    viewCourses: 'View Courses',
    emptyTips: 'Available courses coming soon! View currently available courses provided by Think Academy',
    before: 'Before',
    after: 'After',
  },
  coursesCardTag: {
    new: 'New',
    popular: 'Popular',
    full: 'Full',
    current: 'Current',
    completed: 'Completed',
    refunded: 'Refunded',
    playBack: 'Playback Only',
  },
  getNotifiedConfig: {
    title: 'Can\'t Find an Appropriate Course for Your Child?',
    description: 'That\'s ok! While you take some time to think, leave your email with us to receive admissions support for grammar and independent school entry, links to 11+ webinars and more practice materials.',
    form: {
      grade: 'Child\'s Year group',
      firstName: 'Child\'s first name',
      lastName: 'Last name',
      email: 'Your email',
      platform: 'How did you find out about us?',
    },
    notice: 'Sign up for our mailing list to receive the latest news, promotions and updates! ',
    errorNotice: 'Submission failed. Please try again later.',
    emailError: 'The Email address seems invalid.',
    phoneError: 'The phone number seems invalid.',
    submit: 'Submit',
    success: 'Thank you for your interest in Think Academy!',
  },
  // Cookies声明
  cookiesStatement: {
    description: 'We use cookies to provide you with better services. By clicking any link on this page, your consent has been given.',
  },
  // cookies policy
  cookiesAccept: {
    title: 'Our Use of Cookies',
    description: `<p>We use Cookies to personalise your user experience on our website.</p>
    <p>For more information please see our <a href="/cookies-policy" target="_blank">Cookie Policy</a></p>`,
    accept: 'Accept',
    reject: 'Reject',
  },
  unpaidCourses: {
    tips1: `
      <p class="dotted-para" style="margin-left: 10px; margin-bottom: 10px;">Due to high demand for classes, 
      there is a deadline for switching class. Please select the class you want between: <span style="color: #3e6eff;">{startTime} - {endTime}</span></p>`,
    tips2: `
      <p class="dotted-para" style="margin-left: 10px; margin-bottom: 10px;">Due to high demand for classes, 
      there is a deadline for switching class. Please select the class you want after: <span style="color: #3e6eff;">{startTime}</span></p>`,
    tips3: `
      <p class="dotted-para" style="margin-left: 10px; margin-bottom: 10px;">Due to high demand for classes, 
      there is a deadline for switching class. Please select the class you want before the deadline: <span style="color: #3e6eff;">{endTime}</span></p>`,
  },
  triageDesk: {
    selectChildForEvaluation: 'Please select the child for evaluation:',
    evaluateAnotherChild: 'Conduct an evaluation for another child',
    previousStep: 'Back',
    nextStep: 'Next',
    provideContactInfoForResults: 'Please provide your contact information to get the evaluation results:',
    childName: "Your child's name",
    firstName: 'First name',
    lastName: 'Last name',
    providePhoneNumber: 'Please provide your phone number',
    phoneNumber: 'Phone number',
    provideEmailAddress: 'Please provide your email address',
    emailAddress: 'Email address',
    enterValidPhoneNumber: 'Please enter a valid phone number',
    enterValidEmailAddress: 'Please enter a valid email address',
    provideContactInfoForMaterials: 'Please provide your contact information to get the learning materials:',
    submit: 'Submit',
    submissionSuccessDownload: 'Submission successful! Click to download your learning materials!',
    downloadingAutoClickButton: "Downloading automatically... If it doesn't start, please click the button below to download.",
    download: 'Download',
    selectEvaluationMethod: 'Please select your preferred evaluation method:',
    onlineEvaluation: 'Online Evaluation',
    completeOnlineAssessment: 'Complete the online assessment, and our professional teachers will contact you to analyze the results.',
    evaluationViaZoom: 'Evaluation via Zoom',
    scheduleProfessionalTeacher: 'Schedule a professional teacher to conduct an individual assessment for your child.',
    evaluateInLearningCenter: 'Evaluate in the learning center',
    scheduleVisitCupertino: 'Schedule a visit to {campus}, our professional teachers will conduct a one-on-one assessment for your child.',
    evaluationScheduledSuccess: 'Your evaluation has been successfully scheduled!',
    scheduleSentEmail: 'Your schedule will be sent to your email: {emailAddress}',
    scheduleInformation: 'Schedule information',
    childNameLabel: "Child's name:",
    gradeLabel: 'Grade:',
    dateLabel: 'Date:',
    timeLabel: 'Time:',
    yourPhoneNumberLabel: 'Your phone number:',
    yourEmailAddressLabel: 'Your email address:',
    zoomLinkLabel: 'Zoom link:',
    locationLabel: 'Location:',
    addressLabel: 'Address:',
    contactUsLabel: 'Contact Us:',
    workingHoursLabel: 'Working hours:',
    scheduleAssessment: 'Please schedule your evaluation:',
    noSuitableTimeContactUs: [
      'No suitable time? ',
      'Reselect the evaluation method',
      ' or contact us: Call <span class="color">{phoneNumber}</span> or send an email to <span class="color">{emailAddress}</span>.',
    ],
    selectPreferredTime: 'Please select your preferred time:',
    contactUsInfo: 'No suitable time? Call us at <span class="color">{phoneNumber}</span> or send an email to <span class="color">{emailAddress}</span>.',
    dateHeader: 'Date',
    timeHeader: 'Time',
    slotsHeader: 'Slots',
    fiveLeft: '{num} Left',
    fullClass: 'Full',
    lessons: 'Lessons',
    signUp: 'Enroll',
    switchToCupertinoQuestions: 'Switching to {campus}, we will ask you a few questions again.',
    confirm: 'Confirm',
    cancel: 'Cancel',
    maxStudentAccountsLimit: 'You can add up to 6 student accounts. Please select existing students again.',
    loading: 'Loading...',
    loadingFailed: 'Loading failed',
    retry: 'Retry',
  },
}
